import {Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import {Grid, GridSearchItem} from '../../../../shared/Models/grid';
import {ActionColumn, ActionItem, TextColumn} from '../../../../shared/Models/columns';
import {Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {TranslateService} from '@ngx-translate/core';
import {ExactLogService} from '../../../Services/exact-log.service';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import * as moment from 'moment';
import * as _ from 'lodash';


@Component({
  selector: 'app-exact-crm-updates-overview',
  templateUrl: './exact-crm-updates-overview.component.html',
  styleUrls: ['./exact-crm-updates-overview.component.scss']
})
export class ExactCrmUpdatesOverviewComponent implements OnInit {

  columns = [
    { prop: 'Name', name: 'Name', width: 300},
    { prop: 'Old', name: 'Old', width: 300},
    { prop: 'New', name: 'New', width: 300},
  ];
  rows: any[] = [];
  public grid: Grid;
  public isViewComparison = true;
  @ViewChild('modelTooltip', {static: true}) modelTooltip = null;
  @ViewChild('viewDifference', {static: false}) viewDifference = null;
  public notAllowedSubstrings = [
    '.id',
    '.country',
    'dealerPoints',
    '.userTerms',
    '.collectionDiscounts',
    '.collectionTransportationCosts',
    '.debtor'
  ];

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private router: Router,
    public helper: Helper,
    private translateService: TranslateService,
    private broadcastService: BroadcastService,
    private exactLogService: ExactLogService,
  ) {
  }

  ngOnInit() {
    const dateFormat = 'YYYY-MM-DD hh:mm';
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.exact_crm_update.number',
          prop: 'user.debtor',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => row,
        },
        <TextColumn>{
          name: 'doctrine.exact_crm_update.from',
          prop: '',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          isHtml: true,
          valueFormatter: row => '<a href="' + row.fromUrl + '" target="_blank">' + row.fromName + '</a>',
        },
        <TextColumn>{
          name: 'doctrine.exact_crm_update.to',
          prop: '',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          isHtml: true,
          valueFormatter: row => '<a href="' + row.toUrl + '" target="_blank">' + row.toName + '</a>',
        },
        <TextColumn>{
          name: 'doctrine.exact_log.date',
          prop: 'createdAt',
          sortable: true,
          type: TextColumn.type,
          translate: true,
          maxWidth: 250,
          valueFormatter: row => moment(row).format(dateFormat),
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'feather icon-check fa-lg',
              tooltip: 'global.accept',
              onclick: row => {
                this.exactLogService.acceptExactCrmUpdate(row.id).subscribe((resp) => {
                  this.broadcastService.broadcast('refreshGrid', 'getCrmUpdates');
                  this.exactLogService.getCrmUpdateNotificationsCount();
                });
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'feather icon-x fa-lg',
              tooltip: 'global.reject',
              onclick: row => {
                this.exactLogService.rejectExactCrmUpdate(row.id).subscribe((resp) => {
                  this.broadcastService.broadcast('refreshGrid', 'getCrmUpdates');
                  this.exactLogService.getCrmUpdateNotificationsCount();
                });
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
            <ActionItem>{
              icon: 'fa fa-eye fa-lg',
              tooltip: 'global.view',
              onclick: row => {
                if (this.isViewComparison) {
                  this.isViewComparison = false;
                  this.exactLogService.exactCrmCompare(row.id).subscribe((resp) => {
                    this.isViewComparison = true;
                    this.viewDifference.show();
                    if (!_.isEqual(resp['old'], resp['new'])) {
                      const differences = this.cleanObject(_.pickBy(resp['new'], (value, key) => !_.isEqual(value, resp['old'][key])));
                      const differencesKeys = Object.keys(differences || {});
                      const newRows = [];
                      differencesKeys.map(key => {
                        if (typeof resp['old'][key] === 'object'  &&
                        typeof resp['new'][key] === 'object') {
                          let keyOfObject;
                          if (resp['old'][key]) {
                            keyOfObject = Object.keys(resp['old'][key] || {});
                          } else {
                            keyOfObject = Object.keys(resp['new'][key] || {});
                          }
                          let oldValue;
                          let newValue;
                          let name;
                          keyOfObject.map(oldKey => {
                            name = `${key}.${oldKey}`;
                            if (resp['old'][key] !== null) {
                              if (typeof resp['old'][key][oldKey] === 'string' && resp['old'][key][oldKey].includes('.')) {
                                oldValue = this.translateService.instant(  resp['old'][key][oldKey]);
                              } else {
                                oldValue = resp['old'][key][oldKey];
                              }
                            }

                            if (resp['new'][key][oldKey] !== null) {
                              if (typeof resp['new'][key][oldKey] === 'string' &&  resp['new'][key][oldKey].includes('.')) {
                                newValue = this.translateService.instant(  resp['new'][key][oldKey]);
                              } else {
                                newValue = resp['new'][key][oldKey];
                              }
                            }
                            if ((oldValue || newValue) && oldValue  !== newValue ) {
                              newRows.push({
                                Name: name,
                                Old: oldValue,
                                New: newValue
                              });
                            }
                          });
                        } else {
                          if ((resp['old'][key] || resp['new'][key]) && resp['old'][key] !== resp['new'][key] ) {
                            newRows.push(
                              {
                                Name: key,
                                Old: resp['old'][key],
                                New: resp['new'][key]
                              }
                            );
                          }
                        }
                        });
                      this.rows = [...this.rows, ...newRows];

                      // filter rows
                      this.rows = this.rows.filter(item => !this.notAllowedSubstrings.find(str => item.Name.includes(str)));
                    }
                    this.changeDetectorRef.detectChanges();
                  }, (error) => {
                    this.isViewComparison = true;
                    this.helper.catchError(error);
                  });
                }
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
          ]
        }
      ],
      service: this.exactLogService,
      rememberURL: this.router.url,
      method: 'getCrmUpdates',
      defaultSort: 'createdAt',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: false,
      doseNotHaveSearch: true,
      search: [
        <GridSearchItem>{
          calendarFromDate: 'from',
          calendarToDate: 'to',
          hasCalendar: true,
          type: 'ng-select',
          hasDropdownListFilter: false,
          hasStatus: false,
          hasNormalSearch: true,
          order: [
            {datepickerOrder: 1}
          ],
        }
      ],
    };
  }

  onCloseCompareModal() {
    this.rows = [];
    this.viewDifference.hide();
  }

  cleanObject(object) {
    Object
      .entries(object)
      .forEach(([k, v]) => {
        if (v && typeof v === 'object') {
          this.cleanObject(v);
        }
        if (v && typeof v === 'object' && !Object.keys(v).length || v === null || v === undefined) {
          if (Array.isArray(object)) {
            object.splice(Number(k), 1);
          } else {
            delete object[k];
          }
        }
      });
    return object;
  }


}
